module.exports = __webpack_public_path__ + "static/media/additional_option.a3205a27.svg";